import { Input } from "@/components/ui/input";
import {
  Select,
  SelectContent,
  SelectItem,
  SelectTrigger,
  SelectValue,
} from "@/components/ui/select";
import type { PatronType } from "@/lib/api/patron-types";
import type { DurationPreset, RuleRow } from "./paid-access-rules.types";

interface PaidAccessRuleRowProps {
  row: RuleRow;
  index: number;
  patronTypes: PatronType[];
  onChange: (index: number, row: RuleRow) => void;
}

export function PaidAccessRuleRow({ row, index, patronTypes, onChange }: PaidAccessRuleRowProps) {
  const patch = (partial: Partial<RuleRow>) => onChange(index, { ...row, ...partial });

  return (
    <div className="grid gap-2 rounded-lg border p-3 sm:grid-cols-4">
      <Select value={row.patronTypeId} onValueChange={(v) => patch({ patronTypeId: v })}>
        <SelectTrigger>
          <SelectValue placeholder="Patron type" />
        </SelectTrigger>
        <SelectContent>
          {patronTypes.map((pt) => (
            <SelectItem key={pt.id} value={pt.id}>
              {pt.name}
            </SelectItem>
          ))}
        </SelectContent>
      </Select>
      <Input
        type="number"
        min={0}
        value={row.price}
        onChange={(e) => patch({ price: Number(e.target.value) })}
        placeholder="Price"
      />
      <Select
        value={row.durationPreset}
        onValueChange={(v) => {
          const preset = v as DurationPreset;
          patch({
            durationPreset: preset,
            accessDurationDays:
              preset === "permanent"
                ? null
                : preset === "custom"
                  ? row.accessDurationDays
                  : Number(v),
          });
        }}
      >
        <SelectTrigger>
          <SelectValue />
        </SelectTrigger>
        <SelectContent>
          <SelectItem value="permanent">Permanent</SelectItem>
          <SelectItem value="30">30 days</SelectItem>
          <SelectItem value="90">90 days</SelectItem>
          <SelectItem value="365">1 year</SelectItem>
          <SelectItem value="custom">Custom days</SelectItem>
        </SelectContent>
      </Select>
      {row.durationPreset === "custom" ? (
        <Input
          type="number"
          min={1}
          value={row.accessDurationDays ?? ""}
          onChange={(e) => patch({ accessDurationDays: Number(e.target.value) || null })}
          placeholder="Days"
        />
      ) : (
        <div />
      )}
    </div>
  );
}
